import { memo } from 'react'

import OppositeDay, { TEST_ID } from './OppositeDay'

const OppositeDayComponent = memo(OppositeDay)

export { TEST_ID }

export default OppositeDayComponent
